import React from 'react';
import { Send, CheckCircle, AlertCircle, RefreshCw, Phone, Trash2 } from 'lucide-react';
import { Button } from '../../ui/button';

const DELETE_BTN_STYLE = {
  background: 'transparent',
  border: '1px solid rgba(239,68,68,0.4)',
  color: '#ef4444',
  cursor: 'pointer',
  padding: '6px 12px',
  borderRadius: '8px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '0.85rem',
};

const SenderSelect = ({ staffProfiles, selectedSender, setSelectedSender }) => (
  <div className="sender-select-group">
    <label>Reply as:</label>
    <select
      value={selectedSender}
      onChange={(e) => setSelectedSender(e.target.value)}
      className="sender-select"
    >
      <option value="">-- Randallstown Panthers (General) --</option>
      <optgroup label="Leadership">
        {staffProfiles.leadership.map((p) => (
          <option key={p.id} value={p.id}>{p.name} - {p.title}</option>
        ))}
      </optgroup>
      <optgroup label="Coaches">
        {staffProfiles.coaches.map((p) => (
          <option key={p.id} value={p.id}>{p.name} - {p.title}</option>
        ))}
      </optgroup>
    </select>
  </div>
);

const ReplyForm = ({
  message, staffProfiles, selectedSender, setSelectedSender,
  replyMessage, setReplyMessage, replyLoading, replyStatus,
  onSendReply, onToggleStatus, onDelete,
}) => (
  <div className="reply-form">
    <div className="reply-form-header">
      <Send size={18} />
      <span>Quick Reply</span>
    </div>

    {replyStatus && (
      <div className={`reply-status ${replyStatus.type}`}>
        {replyStatus.type === 'success' ? <CheckCircle size={16} /> : <AlertCircle size={16} />}
        {replyStatus.message}
      </div>
    )}

    <SenderSelect
      staffProfiles={staffProfiles}
      selectedSender={selectedSender}
      setSelectedSender={setSelectedSender}
    />

    <textarea
      value={replyMessage}
      onChange={(e) => setReplyMessage(e.target.value)}
      placeholder="Type your reply here..."
      className="reply-textarea"
      rows={4}
    />

    <div className="reply-actions">
      <Button onClick={onSendReply} className="send-reply-btn" disabled={replyLoading || !replyMessage.trim()}>
        {replyLoading ? (
          <><RefreshCw size={16} className="animate-spin" /> Sending...</>
        ) : (
          <><Send size={16} /> Send Reply</>
        )}
      </Button>

      {message.phone && (
        <a href={`tel:${message.phone}`} className="call-btn-small">
          <Phone size={16} /> Call
        </a>
      )}

      <button className="mark-btn-small" onClick={(e) => onToggleStatus(message, e)}>
        {message.status === 'unread' ? 'Mark Read' : 'Mark Unread'}
      </button>

      <button
        type="button"
        onClick={(e) => onDelete(message, e)}
        title="Delete this message"
        data-testid="delete-contact-modal-btn"
        style={DELETE_BTN_STYLE}
      >
        <Trash2 size={14} /> Delete Message
      </button>
    </div>
  </div>
);

export default ReplyForm;
